/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import EmptyStates from '@/components/common/EmptyStates'
import { TrainingExperience } from '@/types/graphql/types'
import { Button, Title } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'
import { MdAdd } from 'react-icons/md'
import TEItem from './TEItem'
import useTrainingExperiences from '@/hooks/Dashoboard/Members/Profile/TrainingExperiences/useTrainingExperiences'

const TrainingExperiences = ({
  trainingExperience,
  refetch,
}: {
  trainingExperience: TrainingExperience[]
  refetch?: () => void
}) => {
  const { t } = useTranslation('common')

  const { openTrainingExperience, handleUpdate, form, empty } =
    useTrainingExperiences({ refetch, trainingExperience })
  return (
    <div>
      <div className="flex justify-between pt-5">
        <Title order={4}>{t('trainingExperience')}</Title>
        {!empty && (
          <Button
            onClick={() => openTrainingExperience()}
            leftIcon={<MdAdd size={14} />}
          >
            {t('add')}
          </Button>
        )}
      </div>
      {!empty ? (
        form.values.trainingExperience.map(item => (
          <TEItem key={item.id} item={item} handleUpdate={handleUpdate} />
        ))
      ) : (
        <EmptyStates
          description={t('addTrainingExperienceMessage')}
          onClick={() => openTrainingExperience()}
        />
      )}
    </div>
  )
}
export default TrainingExperiences
